export const apiConstants = {
  url: "/api/labelentry"
};
